import presetReact from "@bbob/preset-react";

/*
 * IMPORTANT: Always pass `onlyAllowTags: ALLOWED_BBCODE_TAGS` (or subset) when calling bbobReactRender.
 * Without it, bbob will try to interpret any text in [brackets] as a tag (e.g. "[AMI owner is a minor]"),
 * causing React to attempt rendering unknown HTML elements and crash.
 */
const ALLOWED_BBCODE_TAGS = [
  "b", "i", "u", "s",
  "color", "size",
  "center", "left", "right",
  "abbr",
  "url",
  "list", "*",
  "table", "tr", "td", "th",
];

const bbobExtendedReactPreset = presetReact.extend(tags => ({
  ...tags,
  color: node => ({
    tag: "span",
    attrs: { style: { color: node.attrs.color || Object.keys(node.attrs)[0] } },
    content: node.content,
  }),
  size: node => ({
    tag: "span",
    attrs: { style: { fontSize: `${node.attrs.size || Object.keys(node.attrs)[0]}px` } },
    content: node.content,
  }),
  center: node => ({
    tag: "div",
    attrs: { style: { textAlign: "center" } },
    content: node.content,
  }),
  right: node => ({
    tag: "div",
    attrs: { style: { textAlign: "right" } },
    content: node.content,
  }),
  left: node => ({
    tag: "div",
    attrs: { style: { textAlign: "left" } },
    content: node.content,
  }),
  abbr: node => {
    const title = Object.values(node.attrs).join(" ");
    return {
      tag: "abbr",
      attrs: { title },
      content: node.content,
    };
  },
  table: node => ({
    tag: "table",
    attrs: { className: "overflow-hidden rounded-lg border border-gray-300 border-separate border-spacing-0" },
    content: node.content,
  }),
  tr: node => ({
    tag: "tr",
    attrs: { className: "last:[&>td]:border-b-0 last:[&>th]:border-b-0" },
    content: node.content,
  }),
  td: node => ({
    tag: "td",
    attrs: { className: "border-b border-r border-gray-300 p-2 last:border-r-0" },
    content: node.content,
  }),
  th: node => ({
    tag: "th",
    attrs: { className: "border-b border-r border-gray-300 p-2 font-semibold last:border-r-0" },
    content: node.content,
  }),
}));

export { bbobExtendedReactPreset, ALLOWED_BBCODE_TAGS };
